import { render, staticRenderFns } from "./PLink.vue?vue&type=template&id=63c93ba1"
import script from "./PLink.vue?vue&type=script&lang=js"
export * from "./PLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports